<template>
    <div v-show="show" class="global-search__categories">
        <ul class="category__list filter--list">
            <template v-for="category in categories">
                <li
                        :class="['category--name', category.kind === activeCategory ? 'active': '', categoryIsEnabled(category) ? '': 'disabled', category.kind === kinds.all ? 'hide-smartphone': '' ]"
                        @click="changeResults(category)"
                        :key="category.id">
                    {{ category.name }}&nbsp;<span class="category--count">({{category.count}})</span>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
    import SearchLoading from "../search-loading/search-loading.vue";
    import constants from "../../shared/constants";

    export default {
        name: "search-categories",
        components: {SearchLoading},
        props: {},
        computed: {
            localization() {
                return this.$store.getters.localize;
            },
            activeCategory() {
                return this.$store.state.category;
            },
            show() {
                return this.$store.getters.searchResults;
            },
            kinds() {
                return constants.resultKind;
            },
			categories() {
				return this.$store.getters.categories;
			}
        },
		methods: {
            changeResults(category) {
            	if (this.categoryIsEnabled(category)) {
                    this.$store.dispatch('changeCategory', category.kind);
                    this.$store.dispatch('showDetailView', true);
                }
            },
			categoryIsEnabled(category) {
				return category.count > 0;
			},
        }
    }
</script>
